import React from 'react';

import {isEqual} from 'lodash';
import {batch, useDispatch, useSelector} from 'react-redux';

import * as loadingActions from '@/actions/loadingActions';
import * as setupActions from '@/actions/setupActions';
import {Post} from '@/api/request';
import Button from '@/components/button/Button';
import {DEFAULT_CLEANING_TYPE, DEFAULT_RINSING_DURATION} from '@/constants/calibrationWizardConstant';
import * as APPDATA from '@/constants/pcConstAppData';
import * as APPSTYLE from '@/constants/pcConstAppStyle';

import {INITIAL_CUSTOM_OPERATION} from '../../../stores/reducers/setupStore';

function CompleteWizard() {
  const dispatch = useDispatch();
  const setupStore = useSelector((state) => state.setupStore, isEqual);
  const {cleaningProperties} = setupStore;

  const onClick = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.BTN_EXIT: {
        const resetCleaningProperties = {
          isCleaningWizardRunning: false,
          cleaningDuration: undefined,
          cleaningSolution: 25,
          valveChipType: 6,
          [APPDATA.KEY.MembraneCutOffSize]: undefined,
        };

        batch(() => {
          dispatch(loadingActions.showLoading(false));
          // need to reset the current store value for Custom Operation
          dispatch(setupActions.SetCleaningCustomOperation(INITIAL_CUSTOM_OPERATION));
          dispatch(setupActions.setCleaningProperties(resetCleaningProperties));
          dispatch(setupActions.nextActionWizard(false));
          window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
        });
        break;
      }
      case APPDATA.BTN_RINSE: {
        const cleaningParams = {
          CleaningType: DEFAULT_CLEANING_TYPE,
          CleaningDuration: DEFAULT_RINSING_DURATION,
          MembraneCutOffSize: cleaningProperties[APPDATA.KEY.MembraneCutOffSize]?.toString() || '',
        };

        dispatch(setupActions.nextActionWizard(false));

        Post(
          APPDATA.API.POST_START_CLEANIG_WIZARD,
          cleaningParams,
          successStartCleaningWizard,
          undefined,
          failedStartCleaningWizard,
        );

        break;
      }

      default:
        break;
    }
  };

  const successStartCleaningWizard = (response) => {
    window.location.href = APPDATA.RINSE_WIZARD_ADDRESS;
    let tempCleaningProperties = {...cleaningProperties};
    const responseData = response.data;
    tempCleaningProperties = {
      ...tempCleaningProperties,
      cleaningDuration: responseData.CleaningDuration,
      valveChipType: responseData.ValveChipType,
      CleaningType: responseData.CleaningType,
      MembraneCutOffSize: responseData.MembraneCutOffSize,
      isCleaningWizardRunning: true,
    };

    dispatch(setupActions.setCleaningProperties(tempCleaningProperties));
    dispatch(
      setupActions.backButtonProperties({
        id: APPDATA.BACK,
        label: '',
        disabled: true,
        onClick,
      }),
    );
  };

  const failedStartCleaningWizard = () => {};

  return (
    <div className="complete-wizard center">
      <div className="complete-text">
        <br />
        <span className="title-text">
          <b>The Cleaning Cycle is Finished</b>
          <br />
          <br />
        </span>
        <span className="body-text">
          Rinsing the fluid path is recommended to maintain pH balance.
          <br />
          <ul>
            <li>To rinse and reuse chips, dispose of the NaOH and fill the tubes with 15 mL of water or buffer.</li>
            <li>
              To rinse and store chips, dispose of the NaOH and fill the tubes with 15 mL of preservatives (0.02% sodium
              azide or 0.004% thiomersal) in 20% glycerol.
            </li>
          </ul>
        </span>
      </div>
      <div className="complete-button bottomMenu-show">
        <div className={`${APPSTYLE.COLUMN_1}colButtonBottomMenu`}>
          <Button
            id={APPDATA.BTN_EXIT}
            label={APPDATA.BTN_EXIT}
            onClick={onClick}
            className="buttonBottomMenu secondary-button"
          />
        </div>
        <div className={`${APPSTYLE.COLUMN_1}colButtonBottomMenu`}>
          <Button
            id={APPDATA.BTN_RINSE}
            label={APPDATA.BTN_RINSE}
            onClick={onClick}
            className="buttonBottomMenu primary-button"
          />
        </div>
      </div>
    </div>
  );
}
export default CompleteWizard;
